import * as coding from "./coding.js";
import * as contentItems from "./contentItems.js";
import * as templates from "./templates.js";
import * as valueTypes from "./valueTypes.js";
import * as documents from "./documents.js";

const sr = {
    coding,
    contentItems,
    documents,
    templates,
    valueTypes
};

export default sr;
